import ReactDOM from 'react-dom/client';
import React from 'react';

export const Footer = () =>{
        return(
            <div></div>
        )
}